import { cn } from '@/lib/utils';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const dim = size === 'sm' ? 'w-3 h-3' : size === 'lg' ? 'w-6 h-6' : 'w-4 h-4';
  return (
    <span
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-gray-300 border-t-primary-500',
        dim,
        className,
      )}
      role="status"
      aria-label="Loading"
    />
  );
}
